if (!customElements.get('product-metafield-slider')) {
  customElements.define(
    'product-metafield-slider',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        var swiper = new Swiper(".product-metafield-slider .swiper", {
          loop: true,
          autoplay: { delay: 5000 },
          breakpoints: {
            0: { slidesPerView: 1, spaceBetween: 15 },
            1024: {
              slidesPerView: 3,
              centeredSlides: true,
              initialSlide: 2,
              spaceBetween: 30,
            },
          },
        });
      }
    }
  )
}
